import { defineStore } from "pinia";
import { formData, postData } from "@utils";

export const useCakeStore = defineStore("cake", {
  state: () => ({
    loading: false,
    cakeStep: 1,
    isChangePage: false,
    isDisabledContent: false,
    isContentShow: false,
    isDeliveryShow: false,
    isSummaryShow: false,
    refreshList: false,
    badge: 10,
    minDelivery: 3,
    maxDelivery: 10,
    currentDate:[],
    isOrderStatusChange: 0,
    numberOfPeoples: [10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36],
    cakeTypes: [
      {
        text: "",
        explanation: "",
        value: 0,
        id: "",
        code: "",
        price: 0,
      },
    ],
    cakeCake: [
      { text: "Siyah", value: "siyah" },
      { text: "Beyaz", value: "beyaz" },
    ],
    cakeCream: [
      { text: "Siyah", value: "siyah" },
      { text: "Beyaz", value: "beyaz" },
    ],
    cakeShape: [
      { text: "Kare", value: "kare" },
      { text: "Yuvarlak", value: "yuvarlak" },
    ],
    cakeSus: [
      {
        text: "Süs 1",
        slug: "sus-1",
        explanation: "Süs Açıklaması",
        price: 55,
        image: "sus-1.jpg",
      },
      {
        text: "Süs 2",
        slug: "sus-2",
        explanation: "Süs Açıklaması",
        price: 55,
        image: "sus-2.jpg",
      },
      {
        text: "Süs 3",
        slug: "sus-3",
        explanation: "Süs Açıklaması",
        price: 55,
        image: "sus-3.jpg",
      },
      {
        text: "Süs 4",
        slug: "sus-4",
        explanation: "Süs Açıklaması",
        price: 55,
        image: "sus-4.jpg",
      },
      {
        text: "Süs 5",
        slug: "sus-5",
        explanation: "Süs Açıklaması",
        price: 55,
        image: "sus-5.jpg",
      },
      {
        text: "Süs 6",
        slug: "sus-6",
        explanation: "Süs Açıklaması",
        price: 55,
        image: "sus-6.jpg",
      },
    ],
    cakeOptions: [],
    data: {
      cake: {
        numberOfPeople: 0,
        cakeType: 0,
        specialNumber: 0,
      },

      delivery: {
        deliverydate: "",
      },
      content: {
        cakeShape: "kare",
        cakeCream: "siyah",
        cakeCake: "siyah",
        cakeOptions: [],
        file: [],
        url: [],
        cakeSus: [],
        orderNote: "",
        contentNote: "",
      },
    },
    dataDefault: {
      cake: {
        numberOfPeople: 0,
        cakeType: 0,
        specialNumber: 0,
      },

      delivery: {
        deliverydate: "",
      },
      content: {
        cakeShape: "kare",
        cakeCream: "siyah",
        cakeCake: "siyah",
        cakeOptions: [],
        file: [],
        url: [],
        cakeSus: [],
        orderNote: "",
        contentNote: "",
      },
    },
  }),
  getters: {
    cakeTitle() {
      return (
        (this.data.cake.numberOfPeople || this.data.cake.specialNumber) +
        " Kişilik " +
        this.cakeTypes[this.data.cake.cakeType].text
      );
    },
    cakePrice() {
      return (
        this.cakeTypes[this.data.cake.cakeType].price *
        (this.data.cake.numberOfPeople || this.data.cake.specialNumber)
      );
    },
    cakeType() {
      return this.cakeTypes[this.data.cake.cakeType].text;
    },
    cakePeople() {
      return (this.data.cake.numberOfPeople || this.data.cake.specialNumber) + " Kişilik ";
    },

    deliveryDate() {
      return this.data.delivery.deliverydate;
    },
  },
  actions: {
    increment() {
      this.cakeStep++;
    },
    decrease() {
      this.cakeStep--;
    },
    cakeOrderParams() {
      postData({
        method: "cakeOrderParams",
      }).then((response) => {
        if (response.error) {
          return;
        }
        this.cakeTypes = response.cake_products;
        this.cakeOptions = JSON.parse(response.cake_contents).filter(
          (item) => item.status === true
        );
        this.minDelivery = Number(response.cake_start_day);
        this.maxDelivery = Number(response.cake_end_day);
        this.currentDate = response.cake_dates
      });
    },
    save() {
      this.loading = true;

      const formDatam = new FormData();
      formDatam.append("method", "cakeCreateOrder");
      formDatam.append("product", this.cakeTypes[this.data.cake.cakeType].id);
      formDatam.append("quantity", this.data.cake.numberOfPeople || this.data.cake.specialNumber);
      formDatam.append("deliveryDate", this.data.delivery.deliverydate);
      formDatam.append("cakeShape", this.data.content.cakeShape);
      formDatam.append("cakeCake", this.data.content.cakeCake);
      formDatam.append("cakeCream", this.data.content.cakeCream);
      formDatam.append("contentNote", this.data.content.contentNote);
      formDatam.append("orderNote", this.data.content.orderNote);
      this.data.content.cakeOptions.forEach((item, index) => {
        formDatam.append(`cakeContents[${index}]`, JSON.stringify(item));
      });
      this.data.content.image.forEach((item, index) => {
        console.log(item);
        formDatam.append(`file[${index}]`, item);
      });

      formData(formDatam)
        .then((response) => {
          if (response.error !== 0) {
            return;
          }
        })
        .catch((e) => {
          console.log(e.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
});
